import Vue from 'vue'
import VueBbob from '@bbob/vue2'

Vue.use(VueBbob)
